import { Component, OnInit, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatSnackBar, MatPaginator, MatTableDataSource } from '@angular/material';
import { CaseService } from '../../shared/services/case.service';
import { StatusService } from '../../shared/services/status.service';
import { CaseActionComponent } from '../common/case-action/case-action.component';
import { DownloadUploadComponent } from '../common/downloadUpload/downloadUpload.component';
import { LocalUserService } from '../../shared/services/localUser';
import { CommonService } from '../../shared/services/common.service';
import { environment } from '../../../../environments/environment';
import { AssignGuardianDialogComponent } from '../common/assign-guardian-dialog/assign-guardian-dialog.component';
import { CacheService } from 'app/services/cache.service';
import * as moment from 'moment';
import { FormsService } from 'app/main/shared/services/forms.service';
import { ModeOfPaymentsDialogComponent } from '../../content/common/dailog/mode-of-payments-dialog/mode-of-payments-dialog.component';
import { GuardianConfirmationDialogComponent } from 'app/main/shared/dialog/guardian-confirmation-dialog/guardian-confirmation-dialog.component';
import * as _ from 'lodash';
import { StripePaymentService } from 'app/main/shared/services/stripePayment.service';
import { PaymentFormComponent } from '../common/payments/payment-form/payment-form.component';

@Component({
  selector: 'caseList',
  templateUrl: './caseList.component.html',
  styleUrls: ['./caseList.component.scss'],
  providers: [
    StatusService,
    LocalUserService
  ],
  encapsulation: ViewEncapsulation.None
})
export class CaseListComponent implements OnInit {

  // this will determine what will be shown.
  // here are the list of possible modes
  /*
    your - this will search cases by userId
    open - orgs open cases
    review - cases that need an action
   */
  @Input() mode: string;

  org: string;
  token: string;
  role: string;
  state: string;
  userId: string;

  inputValue: any = '';
  displayedColumns: string[] = ['id', 'form', 'description', 'status', 'submitDate' ,'modifiedDate', 'action'];
  cases = [];
  dataSource = new MatTableDataSource();
  loading = true;

  listOfStatus = [
    'FILED_FOR_CLERK',
    'UPLOAD_FILED_FOR_CLERK',
    'NEEDS_UPLOAD_FROM_CLERK',
    'NEEDS_UPLOAD_FROM_JUDGE',
    'FILED_FOR_JUDGE',
    'APPROVED_BY_JUDGE',
    'UPLOADED_INVENTORY',
    'INVENTORY_AMOUNT_SUBMITTED',
    'INVENTORY_AMOUNT_CHECK_PAID',
    'UPLOAD_JUDGE_SIGNED',
    'APPROVED_BY_CLERK',
    'BOND_UPLOADED',
    'UPLOAD_DOCUMENT',
    'UPLOAD_REPORT_AND_FEES',
    'SET_HEARING',
    'APPOINT_GUARDIAN',
    'SET_JUDGEMENT',
    'RESUBMITTED_FOR_CLERK'
  ];

  guardianData: boolean = false;
  openCaseStatuses = [
    'FILED_FOR_CLERK',
    'FILED_FOR_JUDGE',
    'APPROVED_BY_CLERK',
    'DENIED_BY_CLERK',
    'DENIED_BY_JUDGE',
    'NEEDS_UPLOAD_FROM_CLERK',
    'NEEDS_UPLOAD_FROM_JUDGE',
    'NEEDS_UPLOAD_FROM_PETITIONER',
    'UPLOAD_DENIED_BY_CLERK',
    'UPLOAD_DENIED_BY_JUDGE',
    'UPLOAD_APPROVED_BY_CLERK',
    'UPLOAD_APPROVED_BY_JUDGE',
    'UPLOAD_FILED_FOR_CLERK',
    'UPLOAD_FILED_FOR_JUDGE',
    'BOND_UPLOADED',
    'WAITING_FOR_GA',
    'RESUBMITTED_FOR_CLERK'
  ];

  statusForJudge = [
    'SET_JUDGEMENT',
    'APPOINT_GUARDIAN'
  ];

  dialogRef: any;
  userDetails: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  caseList = [];
  forms: any = null;
  payments: any;

  constructor(
    private router: Router,
    private caseService: CaseService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public statusService: StatusService,
    private localUser: LocalUserService,
    private commonService: CommonService,
    private formsService: FormsService,
    private cacheService: CacheService,
    private stripePaymentService: StripePaymentService
  ) {

    this.org = this.localUser.getOrganizationId();
    this.token = this.localUser.getToken();
    this.role = this.localUser.getRole();
    this.userId = this.localUser.getUserId();
    this.state = this.localUser.getState();
    this.userDetails = this.localUser.getUser();
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    if(this.mode != 'open') {
      this.getCases();
      this.getForms();
    }
  }
  ngOnChanges() {
    if(this.mode == 'open') {
      this.getCases();
      this.getForms();
    }
  }
  getForms() {
    this.loading = true;
    if (this.state !== null) {
      let stateName = this.state;
      // stateName = stateName.split(' ').join('_');
      stateName = stateName.replace(/\s+/g, '_');
      stateName = stateName.toLowerCase();
      this.formsService.getAllForms(stateName)
      .subscribe(result => {
        this.forms = result;
        this.loading = false;
      });
    } else {
      console.error('Not able to fetch form\'s description as User\'s state is found to be null');
    }
  }
  getCases() {
    switch (this.mode) {
      case 'your':
        this.yourCases();
        break;
      case 'open':
        this.openCases();
        break;
      case 'review':
        this.reviewCases();
        break;
    }
  }

  yourCases() {
    this.loading = true;
    this.caseService.getCasesByUserId('', this.userId)
      .subscribe(result => {
        this.cleanCaseList(result);
        this.loading = false;
      },
      error => {
        this.loading = false;
        const errorMessage = 'This page had an error please refresh if this continues contact support';
        this.snackBar.open(errorMessage, '', {
          duration: environment.snackBarErrorLength,
        });
      });
  }

  openCases() {
    this.loading = true;
    this.caseService.getCasesByStatus(this.org, this.openCaseStatuses.join(','))
      .subscribe(result => {
        let cases = [];
        for (let i = 0; i < this.openCaseStatuses.length; i++) {
          cases = cases.concat(result[this.openCaseStatuses[i]]);
        }
        this.caseList = cases;
        this.loading = false;
        this.cleanCaseList(this.caseList);
      });
  }

  reviewCases() {
    this.loading = true;
    let status;
    if(this.role == 'JUDGE') {
      status = this.statusForJudge.join(',');
    }
    else  {
      status = this.listOfStatus.join(',');
    }
    this.caseService.getCasesByStatus(this.org, status)
      .subscribe(result => {
        this.loading = false;
        let cases = [];
        if(this.role == 'JUDGE') {
          for (let i = 0; i < this.statusForJudge.length; i++) {
            cases = cases.concat(result[this.statusForJudge[i]]);
          }
        }
        else {
          for (let i = 0; i < this.listOfStatus.length; i++) {
            cases = cases.concat(result[this.listOfStatus[i]]);
          }
        }
        this.caseList = cases;
        this.cleanCaseList(this.caseList);
      });
  }

  cleanCaseList(list) {
    this.loading = true;
    let entries = [];

    let entry = {
      id: null,
      parentCase: null,
      form: null,
      description: null,
      status: null,
      submitDate: null,
      modifyDate: null,
      tempId: null,
      caseNumber: null,
      name: null,
      dueformId: null,
      gaStatus: null,
      inventoryAmount:null,
      petitionData: null
    };

    for (let i = 0; i < list.length; i++) {

      let data = list[i];

      if (data.summary.status !== 'APPROVED_BY_JUDGE') {

        entry = {
          id: data.id,
          parentCase: null,
          form: data.summary.current_form,
          description: null,
          status: data.summary.status,
          submitDate: data.summary.created_date,
          modifyDate: data.summary.modified_date,
          tempId: null,
          caseNumber: data.summary.case_number,
          name: data.ward.name,
          dueformId: null,
          gaStatus: null,
          inventoryAmount:data.summary.inventoryAmount,
          petitionData: data.petitionData
        };

        entry.tempId = entry.id + entry.parentCase + entry.form;

        entries.push(entry);
      }

      for (let ii = 0; ii < data.due_forms.length; ii++) {

        let dueForm = data.due_forms[ii];

        if ( this.role === 'GUARDIAN' ||  this.role === 'CLERK' || ( (this.role === 'PETITIONER'||this.role === 'ATTORNEY') && dueForm.details.id=='9.2' )) {

          entry = {
            id: dueForm.id,
            parentCase: data.id,
            form: dueForm.details.id,
            description: 'Due: ' + this.commonService.formatTime(dueForm.due_date),
            status: dueForm.status,
            submitDate: dueForm.creation_date,
            modifyDate: dueForm.modified_date,
            tempId: null,
            caseNumber: data.summary.case_number,
            name: data.ward.name,
            dueformId: dueForm.id,
            gaStatus: null,
            inventoryAmount:data.summary.inventoryAmount,
            petitionData: data.petitionData
          };

          if(dueForm.accepted_date) {
            entry.status = "UPLOAD_APPROVED_BY_CLERK";
          }
          else if(dueForm.rejected_date) {
            entry.status = "UPLOAD_DENIED_BY_JUDGE";
          }
          else if(dueForm.submission_date) {
            entry.status = "UPLOAD_FILED_FOR_CLERK";
          }
          else if(dueForm.generation_date) {
            entry.status = "NEEDS_UPLOAD_FROM_GUARDIAN";
          }

          var today = new Date();
          var due_date = new Date(dueForm.due_date);

          if(entry.form =='3.4') {
            entry.status = 'WAITING_FOR_GUARDIAN';
            if(dueForm.accepted_date) {
              entry.status = "UPLOAD_APPROVED_BY_CLERK";
            }
            else if(dueForm.rejected_date) {
              entry.status = "UPLOAD_DENIED_BY_JUDGE";
            }
            else if(dueForm.submission_date) {
              entry.status = "UPLOAD_FILED_FOR_CLERK";
            }
            else if(dueForm.generation_date) {
              entry.status = "NEEDS_UPLOAD_FROM_GUARDIAN";
            }
          }
          else if( (entry.form =='7.1') && dueForm.generation_date == null ) {
            entry.status = 'HIDE_DUEFORM';
          }
          else if( entry.form =='2.8' &&  today <= due_date) {
            entry.status = 'HIDE_DUEFORM';
          }

          entry.tempId = entry.id + entry.parentCase + entry.form;

          if(entry.status != 'HIDE_DUEFORM') {
            if( this.role === 'CLERK') {
              if(entry.status == 'UPLOAD_FILED_FOR_CLERK') {
                entries.push(entry);
              }
            }
            else {
              entries.push(entry);
            }
          }
        }
      }

    }

    this.cases = entries;
    this.cases = this.cases.sort(function (a, b) {
      return b.submitDate - a.submitDate;
    });
    this.loading = false;
    this.dataSource.data = this.cases;
    if(this.dataSource.data.length > 0 && (this.mode == 'review' || this.mode == 'open') && this.role != 'JUDGE') {
      this.getPayments(this.dataSource.data);
    }
    this.loading = false;
  }

  getPayments(cases) {
    this.loading = true;
    let newCases = _.filter(cases,
       obj => (obj.status == 'UPLOAD_FILED_FOR_CLERK' || obj.status == 'INVENTORY_AMOUNT_CHECK_PAID') && obj.form == 'TWOTHREE');
    if(newCases.length > 0) {
      let caseIds = _.map(newCases, obj => obj.id);
      let caseIdStr = caseIds.join(',');
      this.stripePaymentService.getStripePaymentsByCaseIds(caseIdStr)
        .subscribe(result => {
          this.payments = result;
          let tempIds =  _.map(result, obj => obj.id);
          if(tempIds.length > 0) {
            this.dataSource.data = _.filter(this.dataSource.data, function (obj) {
              if( _.includes(tempIds, obj.id) ) {
                if(obj.status == 'UPLOAD_FILED_FOR_CLERK') {
                  return _.set(obj, 'status', 'PAYMENT_REQUIRED');
                }
                else if(obj.status == 'INVENTORY_AMOUNT_CHECK_PAID') {
                  return obj;
                }
              }
              else {
                return obj;
              }
            });
          }
          this.loading = false;
        },
        Error => {
          this.loading = false;
          console.log(Error);
        });
    }
  }

getCaseNumber(id) {
  for (let i = 0; i < this.cases.length; i++) {
    if (this.cases[i].id === id) {
      return (this.cases[i].caseNumber) ? this.cases[i].caseNumber : this.cases[i].name;
    }
  }
}

currentForm(name) {
  switch (name) {
    case 'TWOTHREE':
      return '2.3';
    case 'TWOFOUR':
      return '2.4';
    case 'THREEFOUR':
      return '3.4';
    case 'THREEFIVE':
      return '3.5';
    default:
      return name;
  }
}

getLongForm(value) {
  switch (value) {
    case '2.3':
      return 'TWOTHREE';
    case '2.4':
      return 'TWOFOUR';
    case '3.4':
      return 'THREEFOUR';
    case '2.8':
      return 'TWOEIGHT';
    case '7.1':
      return 'SEVENONE';
    case '3.5':
      return 'THREEFIVE';
    case '9.2':
      return 'NINETWO';
    default:
      return value;
  }
}

  // this returns the current form EX: TWOTHREE
  // give caseID
  getCurrentForm(id) {
    return this.getCase(id).form;
  }

  // this will give you the status of a case EX: FILED_FOR_CLERK
  // give caseId
  getStatus(id) {
    return this.getCase(id).status;
  }

  getCase(id) {
    for (let i = 0; i < this.cases.length; i++) {
      if (this.cases[i].id === id) {
        return this.cases[i];
      }
    }
  }

  getParentCaseOtherwiseReturnId(id) {
    let data = this.getCase(id);
    if (data.parentCase !== undefined && data.parentCase !== null) {
      return data.parentCase;
    }
    return id;
  }

  getStatusText(caseId) {
    let currentForm;
    let status;
    if (caseId.dueformId) {
      status = caseId.status;
      currentForm = this.getLongForm(caseId.form);
    }
    else {
      status = this.getStatus(caseId.id);
      currentForm = this.getLongForm(this.getCurrentForm(caseId.id));
    }
    return this.statusService.getStatusText(this.role, status, currentForm);
  }

  getButtonText(caseId) {
    let currentForm;
    let status;
    if (caseId.dueformId) {
      status = caseId.status;
      currentForm = this.getLongForm(caseId.form);
    }
    else {
      status = this.getStatus(caseId.id);
      currentForm = this.getLongForm(this.getCurrentForm(caseId.id));
    }
    return this.statusService.getButtonText(this.role, status, currentForm);
  }

  findEntry(status, currentForm) {
    for (let i = 0; i < this.cases.length; i++) {
      if (this.cases[i].id === currentForm && this.cases[i].status === status) {
        return this.cases[i];
      }
    }
    return null;
  }

  caseAction(selectedCase) {
    let caseId = selectedCase.id;
    let formId = selectedCase.dueformId;
    let status = selectedCase.status;
    // let currentForm = this.getCurrentForm(caseId);
    let currentForm = selectedCase.form;
    let gaStatus = selectedCase.gaStatus;
    let currentCase;
    if (selectedCase.dueformId) {
      currentCase = this.cases.find(item => item.dueformId === selectedCase.dueformId);
      caseId = currentCase.parentCase;
      status = currentCase.status;
      formId = currentCase.dueformId;

      if (status == 'NEEDS_UPLOAD_FROM_GUARDIAN' && (this.role == 'GUARDIAN' || this.role == 'PETITIONER' || this.role === 'ATTORNEY')) {
        this.dialogRef = this.dialog.open(DownloadUploadComponent, {
          panelClass: 'downloadUpload',
          data: {
            case: caseId,
            temp: caseId,
            form: this.currentForm(currentForm),
            org: this.org,
            form_Id: 'dueForm',
            formId: formId
          }
        });
        this.dialogRef.afterClosed()
          .subscribe(response => {
            this.getCases();
          });
        return;
      }
      else if (status === 'UPLOAD_FILED_FOR_CLERK') {
        this.router.navigate(['cases', this.getParentCaseOtherwiseReturnId(caseId), 'formId', formId, 'pdf', currentForm]);
        return;
      }
      else {
        if (status === 'WAITING_FOR_GUARDIAN' && this.role == 'GUARDIAN') {
          this.dialogRef = this.dialog.open(GuardianConfirmationDialogComponent, {
            // this is data send to the componet
            panelClass:'guardianConfirm',
            width:'350px',
            data: {
              case: caseId,
              temp: caseId,
              form: this.currentForm(currentForm),
              org: this.org,
              form_Id: formId
            }
          });
          this.dialogRef.afterClosed()
            .subscribe(response => {
              var check = "";
              if(response == 'Accept'){
                check = "APPROVE";
              }else if(response == 'Deny'){
                check = "DENY";
              }
              if(check != ""){
                this.caseService.putStatusUpdate(caseId, formId, check)
                  .subscribe(result => {
                    setTimeout(() => {
                      this.loading = true;
                      this.getCases();
                      this.loading = false;
                  }, 2000);
                  });
              }
              
            });
          return;
        }
        if (currentForm === '7.1' && status == null) {
          this.router.navigate(['form', currentForm, 'case', caseId]);
          return;
        }
        else {
          this.router.navigate(['cases', 'form', currentForm, caseId, 'formId', formId]);
          return;
        }
      }
    }

    if (status === 'WAITING_FOR_GA' && (this.role == 'GUARDIANADLITEM'  || this.role == 'CLERK' || this.role == 'JUDGE')) {
      this.dialogRef = this.dialog.open(GuardianConfirmationDialogComponent, {
        // this is data send to the componet
        panelClass:'guardianConfirm',
        width:'350px',
        data: {
          case: caseId,
          temp: caseId,
          form: this.currentForm(currentForm),
          org: this.org,
          form_Id: formId
        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
      return;
    }

    else if (status === 'UPLOAD_DOCUMENT' && (this.role == 'GUARDIANADLITEM'  || this.role == 'CLERK' || this.role == 'JUDGE')) {
      this.dialogRef = this.dialog.open(DownloadUploadComponent, {
        panelClass: 'downloadUpload',
        // this is data send to the componet
        data: {
          case: caseId,
          temp: caseId,
          form: this.currentForm(currentForm),
          org: this.org,
          form_Id: 'PC2.6-GuardianAppointment'

        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
      return;
    }

    else if (status === 'UPLOAD_REPORT_AND_FEES' && (this.role == 'GUARDIANADLITEM'  || this.role == 'CLERK' || this.role == 'JUDGE')) {
      this.dialogRef = this.dialog.open(DownloadUploadComponent, {
        panelClass: 'downloadUpload',
        // this is data send to the componet
        data: {
          case: caseId,
          temp: caseId,
          form: this.currentForm(currentForm),
          org: this.org,
          form_Id: 'Reports_upload',
          petitionData: selectedCase.petitionData,

        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
      return;
    }

    else if (status === 'INVENTORY_AMOUNT_SUBMITTED') {
          const dialogRef = this.dialog.open(ModeOfPaymentsDialogComponent, {
            panelClass: 'modeOfPayments',
            width: '550px',
            data: {
              case: selectedCase,
              temp: caseId,
              form: currentForm,
              org: this.org,
              form_Id: formId,
              type:"INVENTORY",
              formFee:selectedCase.inventoryAmount
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            setTimeout(() => {
              this.loading = true;
              this.getCases();
              this.loading = false;
            }, 3000);
          });
      return;
    }

    else if ((this.role === 'CLERK' || this.role === 'JUDGE') && status === 'UPLOAD_JUDGE_SIGNED') {
      this.dialogRef = this.dialog.open(DownloadUploadComponent, {
        panelClass: 'downloadUpload',
        // this is data send to the componet
        data: {
          case: caseId,
          temp: caseId,
          form: this.currentForm(currentForm),
          org: this.org,
          form_Id: '2.3_judge-signed'

        }
      });
        this.dialogRef.afterClosed()
          .subscribe(response => {
            this.getCases();
          });
        return;
    }

    else if (status === 'SET_JUDGEMENT') {
      this.dialogRef = this.dialog.open(CaseActionComponent, {
        // this is data send to the componet
        panelClass: 'AssignGuardian',
        data: {
          case: caseId,
          org: this.org,
          type: 'JUDGEMENT'
        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
    }

    else if (currentForm === 'TWOTHREE' && status === 'DENIED_BY_CLERK') {
      this.reviewCase(caseId);
      return;
    }

    else if (status === 'UPLOAD_FILED_FOR_CLERK') {
      this.router.navigate(['cases', this.getParentCaseOtherwiseReturnId(caseId), 'pdf', this.currentForm(currentForm)]);
      return;
    }
    else if ( status === 'UPLOADED_INVENTORY') {
      this.router.navigate(['cases', this.getParentCaseOtherwiseReturnId(caseId), 'pdf', '3.3']);
      return;
    }

    // else if(status === 'INVENTORY_AMOUNT_CHECK_PAID' ){
    //   this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
    //     data: {
    //         confirmMessage: 'Inventory amount paid ?'
    //           }
    //       });
    //     this.dialogRef.afterClosed()
    //         .subscribe(response => {

    //           if (response) {
    //             let formData = {
    //               status: 'INVENTORY_AMOUNT_PAID'
    //             };
    //             this.caseService.putCaseNew(this.org, caseId, formData)
    //               .subscribe(result => {
    //                 this.getCases();
    //               });
    //           }else{
    //             // IF Clerk deny the amount paid
    //           }

    //       });
    // }

    // redirect logic
    else if (this.getButtonText(selectedCase) === 'Review' || this.getButtonText(selectedCase) === 'Rereview') {
      this.reviewCase(caseId);
      return;
    }

    else if (this.getButtonText(selectedCase) === 'Pay') {
      let obj = _.find(this.payments, ['id', selectedCase.id]);
      this.dialogRef = this.dialog.open(PaymentFormComponent, {
        panelClass: "confirmDetails",
        data: obj
      });
  
      this.dialogRef.afterClosed()
        .subscribe(response => {
          if(response) {
            this.getCases();
          }
      });
      return;
    }

    else if (this.statusService.getUploadStatus().indexOf(status) !== -1) {
      this.dialogRef = this.dialog.open(DownloadUploadComponent, {
        panelClass: 'downloadUpload',
        // this is data send to the componet
        data: {
          case: this.getParentCaseOtherwiseReturnId(caseId),
          temp: caseId,
          form: this.currentForm(currentForm),
          org: this.org
        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
      return;
    }

    else if ((currentForm === 'TWOTHREE') && (status === 'APPROVED_BY_CLERK' || status === 'DENIED_BY_CLERK') && (this.role == 'GUARDIAN' || this.role == 'PETITIONER' || this.role == 'CLERK' || this.role == 'JUDGE')) {
      this.dialogRef = this.dialog.open(DownloadUploadComponent, {
        panelClass: 'downloadUpload',
        // this is data send to the componet
        data: {
          case: caseId,
          temp: caseId,
          form: this.currentForm(currentForm),
          org: this.org,
          form_Id: 'PC3.1a-bond'
        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
      return;
    }

    else if ((currentForm === 'TWOTHREE') && (status === 'BOND_UPLOADED') && (this.role == 'GUARDIAN' || this.role == 'PETITIONER' || this.role == 'CLERK' || this.role == 'JUDGE')) {
      this.dialogRef = this.dialog.open(DownloadUploadComponent, {
        panelClass: 'downloadUpload',
        // this is data send to the componet
        data: {
          case: caseId,
          temp: caseId,
          form: this.currentForm(currentForm),
          org: this.org,
          form_Id: 'PC3.3-Inventory'
        }
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
      return;
    }

    else if(currentForm ==='TWOTHREE' && status === 'FILED_FOR_JUDGE') {
      this.dialogRef = this.dialog.open(CaseActionComponent, {
        // this is data send to the componet
        panelClass: 'AssignGuardian',
        data: {
          case: caseId,
          org: this.org,
          guardianAdlitem: true
        },
        width:'400px'
      });
      this.dialogRef.afterClosed()
        .subscribe(response => {
          this.getCases();
        });
        return;
    }

    else if (status === 'APPOINT_GUARDIAN' && (this.role === 'CLERK' || this.role === 'JUDGE')) {
      this.caseService.getCaseById(this.org, caseId)
        .subscribe(caseData => {
          this.dialogRef = this.dialog.open(AssignGuardianDialogComponent, {
            panelClass: 'AssignGuardian',
            data: {
              case: caseData,
              org: this.org
            },
            maxWidth: '700px !important'
          });

          this.dialogRef.afterClosed()
            .subscribe(response => {
              this.getCases();
            });
        });
      return;
    }
    else {
      this.openCaseAction(caseId);
    }
    // otherwise it should open up a box to do the action without changes pages.
  }

  openCaseAction(caseId) {
    this.dialogRef = this.dialog.open(CaseActionComponent, {
      // this is data send to the componet
      panelClass: 'AssignGuardian',
      data: {
        case: caseId,
        org: this.org
      }
    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
        this.getCases();
      });
  }

  openCase(caseData) {
    let selectedCase = this.caseList.find(item => item.id === caseData.id);
    this.cacheService.remove('caseData');
    this.cacheService.remove('contacts');
    const expiration = moment(new Date()).add(30, 'minutes').toDate();
    this.cacheService.set('caseData', selectedCase, expiration);
    let caseId = caseData.id;
    {
      this.router.navigate(['case', this.org, this.getParentCaseOtherwiseReturnId(caseId)]);
    }
  }

  // this will redirect you to review the form of that case.
  // use this for TWOTHREE and FILED_FOR_CLERK
  // give caseId only
  reviewCase(id) {
    let theCase = this.getCase(id);
    let form: string = this.currentForm(theCase.form);
    let parentId = theCase.parentCase;
    if (parentId !== null) {
      this.router.navigate(['cases', parentId, 'temp', id, 'form', form]);
    }
    else {
      this.router.navigate(['cases', 'form', form, id]);
    }
  }

  getFromDescription(formNo) {
    if (this.forms !== null && this.forms !== '') {
      return this.forms[formNo];
    }
    return null;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/caseList/caseList.component.ts